import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import FilterComponent from "../../Common/FilterComponent";
import DataTable from "react-data-table-component";

//DataTable
import { AttachmeneTableColumn } from "../../../../Data/DataTables/EmployeeAttachments";

//TYPE
import { ViewEmployeeAttachment } from "../../../../Types/Employee/EmployeeAttachment";
import { CRUDPermissions } from "../../../../Types/Common/Access";

//SERVICES
import {
  VIEW_EMPATTACHMENTS_QUERY_KEY,
  employeeAttachmentsService,
} from "../../../../Services/employeeAttachmentServices";

interface EmployeeProfileProps {
  EmpNo: string;
  access: CRUDPermissions;
}

const AttachmentsTable = ({ EmpNo, access }: EmployeeProfileProps) => {
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const { data: attachmentResponse, isLoading: attachmentIsLoading } =
    useQuery<{ data: ViewEmployeeAttachment[] }>({
      queryKey: [...VIEW_EMPATTACHMENTS_QUERY_KEY, EmpNo],
      queryFn: () =>
        employeeAttachmentsService.viewEmployeeAttachment(EmpNo as string),
    });

  const attachmentData = attachmentResponse?.data ?? [];

  const filteredItems: ViewEmployeeAttachment[] = attachmentData.filter(
    (item) =>
      Object.values(item).some(
        (value) =>
          value != null &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={AttachmeneTableColumn(access)}
          striped={true}
          pagination
          progressPending={attachmentIsLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default AttachmentsTable;
